import './cards.scss';

import React from 'react';

import ComingSoon from '../../assets/icons/soon.svg';

function Cards() {
  return (
    <div className="cards">
      <div className="cards__image">
        <img src={ComingSoon} alt="Coming soon" />
      </div>
      <h1 className="page__title">
        Coming <span className="text-cursive">soon!</span>
      </h1>
      <p className="cards__text text-secondary">
        Cards are currently brewing! <br />
        We are working hard to get this ready for you.
      </p>
    </div>
  );
}

export { Cards };
